export default {
  init() {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    isIE11 && $('body').addClass('is-ie11');
  },
};
